import {
  Box,
  Button,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Modal,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React, { useEffect, useRef, useState } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Pending from "@mui/icons-material/Pending";
import Details from "./Details";
// import { useMessage } from '../../components/Header';
import useLoader from "../../hooks/useLoader";
import useErrorHandler from "../../hooks/useErrorHandler";
import axios from "axios";
import { useMessage } from "../../components/Header";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useTheme } from "../../style/theme";
import { TfiMoreAlt } from "react-icons/tfi";
import { MdExpandLess } from "react-icons/md";
import { IoIosMore } from "react-icons/io";
import { TbEdit } from "react-icons/tb";

// import CreateMemo from './CreateMemo';

const DocsCard = (props) => {
  const { title, content, joblistings, id, refresh, editDoc,
    //  copyDoc
     } = props;
  const [accordionOpen, setAccordionOpen] = useState(false);
  const { loaderState, start, end } = useLoader();
  const errorHandler = useErrorHandler();
  const { showError, showSuccess } = useMessage();

  const [deletingModal, setDeleting] = useState(false);
  const OpenDeleteModal = () => setDeleting(true);
  const CloseDeleteModal = () => setDeleting(false);
  const [openModal, setOpenModal] = useState(false);
  const toggleModal = () => {
    setOpenModal((prev) => !prev);
  };
  const modalRef = useRef(null); // Reference for the modal content
  const buttonRef = useRef(null); // Reference for the button that opens the modal

  useEffect(() => {
    // Function to handle clicks outside the modal
    const handleClickOutside = (event) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target) &&
        !buttonRef.current.contains(event.target)
      ) {
        setOpenModal(false); // Close the modal if clicked outside
      }
    };

    // Add event listener for clicks outside
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup the event listener on unmount
    // return () => {
    //   document.removeEventListener('mousedown', handleClickOutside);
    // };
  }, []);

  const handleExpand = () => {
    setAccordionOpen((show) => !show);
  };

  async function deleteDoc(id) {
    start();
    try {
      const res = await axios.delete(`/hr/docs/${id}`);
      const { success, message } = res.data;
      if (success) {
        showSuccess("Docs deleted");
      } else {
        showError(message);
      }
    } catch (e) {
      errorHandler(e);
    } finally {
      end();
      refresh();
    }
  }

  const { mode } = useTheme();
  return (
    <div className="">
      <div className="flex justify-between gap-7 items-center py-4 items-center">
        <div
          style={{
            borderRadius: "8px",
            border: "1px solid #2B2B2B",
          }}
          className="px-4 w-full hidden sm:flex flex-col"
        >
          <div className="flex justify-between items-center w-full">
            <div className="py-2">
              <p className="text-[16px] font-[700]">{title}</p>
              <div className="flex justify-between items-center">
                <div className="flex gap-6">
                  {joblistings.map((job) => (
                    <p
                      className="text-[14px] font-[400]  text-[#0080FF]"
                      mr={1}
                      key={job._id}
                    >
                      {job.title}
                    </p>
                  ))}
                </div>
              </div>
            </div>
            <div className="flex">
              <Button
                sx={{
                  color: "#0080FF",
                  textTransform: "capitalize",
                  fontSize: "14px",
                  mr: 2,
                }}
                onClick={handleExpand}
                variant="text"
                endIcon={<ExpandMoreIcon />}
              >
                show details
              </Button>
            </div>
          </div>
          {accordionOpen && <Details content={content} title={title} />}
        </div>

        <div className="relative">
          <div
            className={` ${
              mode === "dark" ? "bg-[#171717]" : ""
            } hidden sm:flex h-[55px] rounded-md flex cursor-pointer  justify-center items-center p-4`}
            onClick={toggleModal}
            ref={buttonRef}
          >
            <TfiMoreAlt className="relative font-extrabold" size="20px" />
          </div>
        </div>
      </div>

      {/* {mobile screen} */}
      <div
        className={`${
          mode === "dark" ? "bg-[#171717]" : ""
        } px-2 py-4 rounded-[8px] sm:hidden relative`}
        ref={buttonRef}
      >
        <div className="flex justify-between items-center ">
          <div>
            <p
              className={`text-[14px] mb-2 font-[700]  ${
                mode === "dark" ? "text-[#ffffff]" : ""
              } `}
            >
              {title}
            </p>

            <div className="flex flex-wrap gap-4">
              {joblistings.map((job) => (
                <p
                  className="text-[12px] font-[400]  text-[#0080FF]"
                  mr={1}
                  key={job._id}
                >
                  {job.title}
                </p>
              ))}
            </div>
          </div>

          <div className="relative">
            <IoIosMore size={20} className="relative" onClick={toggleModal} />
          </div>
        </div>

        <div className="flex justify-between items-center">
          <Button
            sx={{
              padding: "0px",
              marginTop: "20px",
              textTransform: "capitalize",
              fontSize: "12px",
              color: "#0080FF",
              mr: 2,
            }}
            onClick={handleExpand}
            variant="text"
            endIcon={
              accordionOpen ? (
                <MdExpandLess color="#0080FF" />
              ) : (
                <ExpandMoreIcon color="#0080FF" />
              )
            }
          >
            Show details
          </Button>
        </div>

        {accordionOpen && <Details content={content} title={title} />}
      </div>

      {openModal && (
        <div
          ref={modalRef}
          className="absolute right-[40px] sm:right-[70px] mt-[-80px] sm:mt-[-10px] shadow-lg flex-col flex gap-3 rounded-md w-[149px] h-[80px] text-white px-4 py-3 bg-[#1B1B1B] z-10"
        >
          <div className="flex items-center gap-3" onClick={() => editDoc(id)}>
            <TbEdit style={{ fontSize: "20px" }} />
            <p>Edit</p>
          </div>

          {/* <div className="flex items-center gap-3" onClick={() => copyDoc(id)}>
            <ContentCopyIcon fontSize="small" />
            <p>Copy</p>
          </div> */}

          {/* onClick={() => OpenDeleteModal(id)} */}
          <div className="flex items-center gap-3" onClick={OpenDeleteModal}>
            <DeleteIcon fontSize="small" />

            <p>Delete</p>
          </div>
        </div>
      )}

      {deletingModal && (
        <Modal open={OpenDeleteModal} onClose={CloseDeleteModal}>
          <Box
            sx={{ backgroundColor: "background.paper" }}
            className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 p-6 rounded-lg shadow-lg w-[90%] md:w-[450px]"
          >
            {/* Title */}
            <h2 className="text-lg font-bold mb-3">Delete Docs</h2>

            {/* Message */}
            <p className="text-sm mb-2 text-[#A5A5A5]">
              Are you sure you want to delete <b>{title}</b>?
            </p>
            <p className="text-red-500 text-sm mt-10 my-5">
              This action cannot be undone.
            </p>

            {/* Buttons */}
            <div className="flex justify-end gap-3">
              <Button
                onClick={() => {
                  deleteDoc(id);
                  CloseDeleteModal();
                }}
                color="error"
                variant="outlined"
                sx={{ paddingX: { md: 2, xs: 0 } }}
              >
                Delete
              </Button>
              <Button
                onClick={CloseDeleteModal}
                color="primary"
                variant="contained"
                sx={{ bgcolor: "#0080FF", borderRadius: "5px" }}
              >
                Cancel
              </Button>
            </div>
          </Box>
        </Modal>
      )}

      {/* {deletingModal && (
        <Dialog
          maxWidth="sm"
          fullWidth
          open={OpenDeleteModal}
          onClose={CloseDeleteModal}
        >
          <div
            className="p-[10px] sm:p-[20px] "
            style={{ backgroundColor: mode === "dark" ? "#171717" : "" }}
          >
            <DialogTitle>Delete Docs</DialogTitle>
            <DialogContent
              sx={{ backgroundColor: mode === "dark" ? "#171717" : "" }}
            >
              <p className="text-[#A5A5A5] text-[10px] sm:text-[14px]">
                Are you sure you want to delete <b>{title}</b>?
              </p>

              <p className="text-[#FF3D3D] mt-[30px] text-[10px] sm:text-[14px]">
                This action cannot be undone.
              </p>
            </DialogContent>
            <DialogActions
              sx={{ backgroundColor: mode === "dark" ? "#171717" : "" }}
            >
              <Button
                onClick={CloseDeleteModal}
                color="primary"
                variant="contained"
              >
                Cancel
              </Button>
              <Button
                onClick={() => {
                  deleteDoc(id);
                  CloseDeleteModal();
                }}
                color="error"
                variant="outlined"
              >
                Delete
              </Button>
            </DialogActions>
          </div>
        </Dialog>
      )} */}
    </div>
  );
};

export default DocsCard;
